import React, {Dispatch, SetStateAction, useEffect} from "react";
import {Card, CardBody, CardHeader, Col, Form, FormGroup, Input, Label, Row} from "reactstrap";
import InputComponent from "../Shared/Inputs/InputComponent";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCalendar} from "@fortawesome/free-solid-svg-icons";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../Store/Reducers";
import InputCreateSelectComponent from "../Shared/Inputs/InputCreateSelectComponent";
import Contact from "../../Models/Contact";
import {ModalActions} from "../../Store/Modal/Slice";
import {ADDRESS_MODAL, ADDRESSES_LIST_MODAL, CONTACT_MODAL, CONTACTS_LIST_MODAL} from "../../Store/Modal/Types";
import DatePickerComponent from "../Shared/Inputs/DatePickerComponent";
import TimePickerComponent from "../Shared/TimePickerComponent/TimePickerComponent";
import Select from "react-select";
import Address from "../../Models/Address";
import {equalsTime, timeGreaterThan, timeLessThan} from "../../Utils/Utils";
import {FormType} from "../../Models/FormType";
import {Customer} from "../../Models/Customer";
import {getCityByKey} from "../../Services";
import City from "../../Models/City";

type Props = {
  setValue: (fieldName: string, value: any) => void;
  getValues: () => any;
  setError: (fieldName: string, value: any) => void;
  clearErrors: (fieldName: string) => void;
  register: (fieldName: string) => void;
  comments?:string;
  setComments?: Dispatch<SetStateAction<string | any>>;
}

const ShipmentFormComponent: React.FC<Props> = ({setValue, getValues, setError, clearErrors, register,setComments,comments}) => {

  const dispatch = useDispatch();

  useEffect(()=>{
    register('address.city._KEY');
    register('address._KEY');
    // register('packing_type._KEY');
    // register('packing_type.name');
  },[register]);

  const {
    CompanyReducer: {company_selected, branch_selected},
    PackingReducer: {packingTypesOptionList},
    PaymentReducer: {paymentTypesOptions},
    authReducer: {branchOptions}
  } = useSelector((state: RootState) => state);

  const onSelectContact = (e: any, cb: (contact?: Contact) => void) => {
    e.preventDefault();
    dispatch(ModalActions.openModal({
      modal: CONTACTS_LIST_MODAL,
      data: {
        client: branch_selected || company_selected,
      },
      cb: cb
    }))
  };

  const onSelectAddress = (address?: Address) => {
    if (address) {
      setValue('address',address);
      //When create an address
      if (typeof address.city === "string") {
        getCityByKey(address.city as string).then((res: any) => {
          address.city = (res.results as Array<City>)[0] as City;
          setValue("address", address);
        });
      }
    }
  };

  const openAddressModal = () => {
    dispatch(ModalActions.openModal({
      modal: ADDRESSES_LIST_MODAL,
      data: {
        client: branch_selected || company_selected
      },
      cb: onSelectAddress
    }))
  };

  const onChangeTimeFrom = (time?: Date, check?: boolean) => {
    if (
      time && getValues()?.pickup_time_to &&
      (timeGreaterThan(time, getValues()?.pickup_time_to as Date) || equalsTime(time, getValues()?.pickup_time_to as Date))
    ) {
      setError("pickup_time_from", {type: "custom", message: "Recogida 'desde' debe ser inferior a recogida 'hasta'"})
    } else {
      clearErrors("pickup_time_from");
    }

    if (check) onChangeTimeTo(getValues()?.pickup_time_to as Date);
  };

  const onChangeTimeTo = (time?: Date, check?: boolean) => {
    if (
      time && getValues()?.pickup_time_from &&
      (timeLessThan(time, getValues()?.pickup_time_from as Date) || equalsTime(time, getValues()?.pickup_time_from as Date))
    ) {
      setError("pickup_time_to", {type: "custom", message: "Recogida 'hasta' debe ser superior a recogida 'desde'"})
    } else {
      clearErrors("pickup_time_to");
    }

    if (check) onChangeTimeFrom(getValues()?.pickup_time_from as Date);
  };

  const onCreateAddress = () => {

    dispatch(ModalActions.openModal({
      modal: ADDRESS_MODAL,
      data: {
        model: '',
        formType: FormType.INSERT
      },
      cb: onSelectAddress
    }))

  };

  const setContactSelected = (field: string, contact?: Contact) => contact && setValue(field, contact);

  const onSelectContactPickup = (e: any) => onSelectContact(e, cbContactPickupSelected);

  const onCreateContactPickup = (e: any) => onCreateContact(e, cbContactPickupSelected);

  const cbContactPickupSelected = (contact?: Contact) => setContactSelected("contact_pickup", contact);

  const onCreateContact = (e: any, cb: (contact?: Contact) => void) => {
    e.preventDefault();
    dispatch(ModalActions.openModal({
      modal: CONTACT_MODAL,
      data: {
        formType: FormType.INSERT,
        model: (branch_selected as Customer)?._KEY || (company_selected as Customer)?._KEY
      },
      cb: cb
    }))
  };

  return (
    <Form>
      <Row>

        <Col lg={4}>
          <InputComponent
            label="CLIENTE"
            name="paying_customer"
            disabled
          />
        </Col>

        <Col lg={4}>
          <FormGroup>
            <InputComponent
              label="FECHA DE RECOGIDA"
              name="call_date"
              required
              render={({onChange, value}) => (
                <DatePickerComponent
                  value={new Date(value)}
                  onChange={onChange}
                  calendarIcon={<FontAwesomeIcon icon={faCalendar}/>}
                  minDate={new Date()}
                  noClearIcon
                />
              )}
            />
          </FormGroup>
        </Col>

        <Col lg={4}>
          <FormGroup>
            <InputComponent
              label="RECOGIDA EXPRESS"
              name="express"
              render={({onChange, value}) => (
                <div className="radio">
                  <label className="radio-inline">
                    <input
                      name="_express"
                      type="radio"
                      defaultChecked={value}
                      onChange={() => setValue("express", true)}
                    /> Si
                  </label>
                  <label className="radio-inline">
                    <input
                      name="_express"
                      type="radio"
                      defaultChecked={value === false}
                      onChange={() => setValue("express", false)}
                    /> No
                  </label>
                </div>
              )}
            />
          </FormGroup>
        </Col>

        <Col lg={4}>
          <FormGroup>
            <InputComponent
              label="UNIDAD DE EMPAQUE"
              name="packing_type"
              required
              render={({onChange, value}) => (
                <Select
                  onChange={onChange}
                  value={value}
                  isLoading={!packingTypesOptionList?.length}
                  options={packingTypesOptionList}
                  isDisabled={!packingTypesOptionList.length}
                />
              )}
            />
          </FormGroup>
        </Col>

        <Col lg={4}>
          <InputComponent
            label="TIPO DE PAGO"
            name="payment_type"
            required
            render={({onChange, value}) => (
              <Select
                isLoading={!paymentTypesOptions.length}
                options={paymentTypesOptions}
                isDisabled={!paymentTypesOptions.length}
                onChange={onChange}
                value={value}
              />
            )}
          />
        </Col>

        <Col lg={4}>
          <InputComponent
            label="SUCURSAL"
            name="branch"
            required
            render={({onChange, value}) => (
              <Select
                options={branchOptions}
                onChange={onChange}
                value={value}
              />
            )}
          />
        </Col>

        <Col lg={12}>
          <FormGroup>
            <Label>OBSERVACIONES</Label>
            <Input value={comments}
                   onChange={setComments && (e => setComments(e.target.value))}
                   type="textarea" name="comments" id="comments"/>
          </FormGroup>
        </Col>


        <Col lg={12}>
          <br/>
          <Card>
            <CardHeader>RECOGIDA</CardHeader>
            <CardBody>
              <Row>

                <Col lg={6}>
                  <InputComponent
                    label="HORA RECOGIDA DESDE"
                    name="pickup_time_from"
                    required
                    render={({onChange, value}) => (
                      <TimePickerComponent
                        value={new Date(value)}
                        onChangeTime={(time: any) => {
                          if (time instanceof Date) {
                            onChange(time);
                            onChangeTimeFrom(time, true);
                          }
                        }}
                      />
                    )}
                  />
                </Col>

                <Col lg={6}>
                  <InputComponent
                    label="HORA RECOGIDA HASTA"
                    name="pickup_time_to"
                    required
                    render={({onChange, value}) => {
                      return (
                        <TimePickerComponent
                          value={new Date(value)}
                          onChangeTime={(time: any) => {
                            if (time instanceof Date) {
                              onChange(time);
                              onChangeTimeTo(time, true);
                            }
                          }}
                        />
                      )
                    }}
                  />
                </Col>

                <Col lg={6}>
                  <FormGroup>
                    <InputComponent
                      label="CONTACTO DE RECOGIDA"
                      required
                      name="contact_pickup"
                      render={({onChange, value}) => (
                        <InputCreateSelectComponent
                          size="md"
                          onList={onSelectContactPickup}
                          onNew={onCreateContactPickup}
                          selected={value ? `${value?.name} ${value?.last_name}` : ""}
                        />
                      )}
                    />
                  </FormGroup>
                </Col>

                <Col lg={6}>
                  <FormGroup>
                    <InputComponent
                      label="DIRECCIÓN DE RECOGIDA"
                      required
                      name="address.address"
                      render={({onChange, value}) => (
                        <InputCreateSelectComponent
                          size="md"
                          onList={openAddressModal}
                          onNew={onCreateAddress}
                          selected={value}
                        />
                      )}
                    />
                  </FormGroup>
                </Col>

              </Row>
            </CardBody>
          </Card>
        </Col>

      </Row>
    </Form>
  );
};

export default ShipmentFormComponent;
